




































import Vue from 'vue';
import CourseSelectionForm from '@/components/forms/CourseSelectionForm.vue';
import LoggedAccountConfirmation from '@/components/LoggedAccountConfirmation.vue';
import PipelineMenuWrapper from '@/components/PipelineMenuWrapper.vue';
import pipeline from '@/pipeline';
import { Course } from '@/store/modules/course/state';
import Analytics from '@/helpers/analytics';
import { Toast } from '@/components/ds';
import { AnalyticsActions } from '@/store/modules/analytics/actions';
import accountsIframe from '@/helpers/accountsIframe';
import { isAccountConfirmed, saveConfirmedAccount } from '@/helpers/confirmedAccountStorage';
import VIEWS_NAMES from '@/router/viewsNames';

export default Vue.extend({
  components: {
    PipelineMenuWrapper,
    CourseSelectionForm,
    LoggedAccountConfirmation,
    Toast,
  },
  data() {
    return {
      error: false,
      showAccountConfirmation: false,
      // curso clicado enquanto a confirmação da conta está aberta
      pendingCourse: null as Course | null,
    };
  },
  computed: {
    name(): string {
      return this.$store.getters.userFirstName;
    },
    availableCourses(): string[] {
      return this.$store.getters.availableCourses || [];
    },
    selectedCourse(): string {
      return this.$store.getters.selectedCourse?.id;
    },
    // conta da admissão, não a do POCKET: é a ligada ao token
    accountEmail(): string {
      return this.$store.getters.user?.email || '';
    },
    accountName(): string {
      return this.$store.getters.user?.name || '';
    },
  },
  watch: {
    // pergunta já na chegada: quem volta com o cookie cai direto nesta etapa
    accountEmail: {
      immediate: true,
      handler(): void {
        if (this.needsAccountConfirmation()) this.showAccountConfirmation = true;
      },
    },
  },
  created() {
    this.$store.dispatch('PULL_AVAILABLE_COURSES');
  },
  methods: {
    // 2ª confirmação, mesma chave da 1ª; cobre quem entrou pelo cookie e pulou a 1ª
    needsAccountConfirmation(): boolean {
      return Boolean(this.accountEmail) && !isAccountConfirmed(this.accountEmail);
    },
    async selectedHandler(course: Course) {
      if (this.needsAccountConfirmation()) {
        this.pendingCourse = course;
        this.showAccountConfirmation = true;
        return;
      }

      await this.proceedWithCourse(course);
    },
    async confirmAccount() {
      const course = this.pendingCourse;

      saveConfirmedAccount(this.accountEmail);
      this.showAccountConfirmation = false;
      this.pendingCourse = null;

      if (course) await this.proceedWithCourse(course);
    },
    async switchAccount() {
      accountsIframe.logout();
      // sem isso a próxima visita entraria na admissão da outra pessoa
      await this.$store.dispatch('CLEAR_LOGIN_DATA');

      // reload, não router.push: o guard devolveria para a etapa atual
      const { href } = this.$router.resolve({
        name: VIEWS_NAMES.SIGN_UP,
        query: this.$route.query,
      });
      window.location.assign(href);
    },
    async proceedWithCourse(course: Course) {
      await this.$store
        .dispatch('UPDATE_COURSE', { course })
        .catch(error => this.errorHandler(error));

      this.$store.dispatch(AnalyticsActions.COURSE_CHOSEN, {
        grad_curso_escolhido: course.name,
        course: course.name,
      });
      Analytics.trackGTM({
        event: 'course_selected',
        grad_selected_course: course.name,
        processo_seletivo_id: this.$store.getters.admissionId,
      });

      pipeline.next();
    },
    errorHandler(error: any) {
      this.error = true;
      setTimeout(() => {
        this.error = false;
      }, 5000);
      throw error;
    },
  },
});
